import React from "react";
import Profile from "./Profile";

function Main(){
    return(
       <Profile />
    )
}

export default Main;